// service
import { getGroups } from "../../../../utils/services/group";

// colunas da tabela para leitura do erro
export const excelColumnsPtBr = {
  Descricao: "description",
};

export const excelColumnsPtBrDelete = {
  Descricao: "description",
  Id: "id",
};

// colunas da tabela na hora de receber
export function allExcelColumns(row, index) {
  const formatedRow = {
    index,
    description: row.description,
  };

  return formatedRow;
}

export function allExcelColumnsDelete(row, index) {
  const formatedRow = {
    index,
    id: row.id,
    description: row.description,
  };

  return formatedRow;
}

// vrificar colunas vazias
export function findRowsWithError(validRows) {
  const rowsWithError = validRows.filter(
    (row) =>
      Object.values(row).filter((value) => value === undefined).length > 0,
  );
  return rowsWithError;
}

// get da api para receber os grupos do evento
export async function getAllGroups(idEvent) {
  var dataReturn = [];

  const res = await getGroups({
    eventId: idEvent,
    offset: 1,
    limit: 9999,
    search: "",
  });

  if (res?.findOneGroupData?.data) {
    dataReturn = res.findOneGroupData.data;
  }

  return dataReturn;
}

// validar duplicidade nas linhas e se ja tem na api
export async function validDuplicates(rows, idEvent) {
  const groupsApi = await getAllGroups(idEvent);

  var duplicates = [];

  if (rows.length > 0) {
    rows.map((row) => {
      if (duplicates.find((e) => e.index === row.index)) {
        return;
      }

      const searchRow = rows.filter((e) => e.description === row.description);

      if (searchRow.length > 1) {
        duplicates.push({
          ...row,
          description: undefined,
        });
      } else {
        // verificar duplicidade com dados da api
        const searchApi = groupsApi.find(
          (group) => group.name === row.description,
        );

        if (searchApi) {
          duplicates.push({
            ...row,
            description: undefined,
          });
        }
      }
    });
  }

  return duplicates;
}

// verificar duplicidade de ids nas linhas
export async function duplicatesIds(rows) {
  // contar ids
  const count = rows.reduce((acc, item) => {
    acc[item.id] = (acc[item.id] || 0) + 1;
    return acc;
  }, {});

  // pega duplicados e seta id undefined
  const duplicated = rows
    .filter((item) => count[item.id] > 1)
    .map((item) => ({
      ...item,
      id: undefined,
    }));

  return duplicated;
}

// ids das linhas que não tem na api para ação deletar / atualizar
export async function invalidsIds(rows, idEvent) {
  const groupsApi = await getAllGroups(idEvent);

  var invalidsIds = [];

  if (groupsApi.length > 0) {
    rows.map((row) => {
      const search = groupsApi.find((group) => group.id === row.id);

      if (!search)
        invalidsIds.push({
          ...row,
          id: undefined,
        });
    });
  }

  return invalidsIds;
}
